module.exports = __webpack_public_path__ + "static/tomato-12b79ad5cbec372e3d700fc66811191d.svg";